<template>
    <div class="quiz-container">
        <div class="quiz-content">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>
                    <span class="color-blue" @click="goBackThree">班级管理</span>
                </el-breadcrumb-item>
                <el-breadcrumb-item>
                    <span class="color-blue" @click="goBackTwo">{{ className }}</span>
                </el-breadcrumb-item>
                <el-breadcrumb-item>
                    <span class="color-blue" @click="goBack">小测列表</span>
                </el-breadcrumb-item>
                <el-breadcrumb-item>{{ paperName }}</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="quiz-list">
                <el-table
                    :data="unCommittedList"
                    border
                    style="width: 100%; flex: 1; margin-top: 20px"
                    height="1%"
                    size="medium"
                    :header-cell-style="{
                        fontWeight: 'normal',
                        color: '#333',
                        background: '#f5f7fa',
                        textAlign: 'center'
                    }"
                    :cell-style="{ fontSize: '12px', color: '#333', textAlign: 'center' }"
                >
                    <el-table-column prop="s_name" label="学生姓名"></el-table-column>
                    <el-table-column label="成绩">
                        <template slot-scope="scope">
                            <span>--</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="提交时间">
                        <template slot-scope="scope">
                            <span>--</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="状态">
                        <template slot-scope="scope">
                            <span>--</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="批阅人">
                        <template slot-scope="scope">
                            <span>--</span>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                    class="pages-center"
                    background
                    style="margin: 20px 0"
                    :current-page.sync="quizPages.currentPageNum"
                    :page-size="quizPages.eachPageNum"
                    :total="quizPages.total"
                    layout="prev, pager, next, jumper"
                    @current-change="quizCurrentChange"
                >
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            quizId: Number(this.$route.query.quizId) || '',
            classId: Number(this.$route.query.classId) || '',
            className: this.$route.query.className || '',
            paperName: this.$route.query.paperName || '',
            unCommittedList: [],
            quizPages: {
                currentPageNum: 1,
                eachPageNum: 10,
                total: 0
            }
        }
    },
    mounted() {
        this.getUnCommittedList()
    },
    methods: {
        getUnCommittedList() {
            let params = {
                quiz_id: this.quizId,
                c_id: this.classId,
                is_read: 2,
                page: this.quizPages.currentPageNum,
                limit: this.quizPages.eachPageNum
            }
            this.$shttp.axiosGetBy(this.$api.getRecordList, params, res => {
                if (res.code === 200) {
                    this.unCommittedList = res.data.data
                    this.quizPages.total = res.data.total
                }
            })
        },
        quizCurrentChange(val) {
            this.quizPages.currentPageNum = val
            this.getUnCommittedList()
        },
        goBack() {
            this.$router.go(-1)
        },
        goBackTwo() {
            this.$router.go(-2)
        },
        goBackThree() {
            this.$router.go(-3)
        }
    }
}
</script>

<style scoped lang="scss">
::v-deep .el-breadcrumb {
    .el-breadcrumb__inner {
        color: #000;
    }
}
.quiz-container {
    width: 100%;
    height: calc(100% - 40px);
    padding: 20px 0;
    .quiz-content {
        width: 1200px;
        height: 100%;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        .quiz-list {
            display: flex;
            flex-direction: column;
            height: 1%;
            flex: 1;
            background: #fff;
            margin-top: 20px;
            .course-list {
                padding: 20px;
            }
        }
    }
}
</style>
